module.exports = __webpack_public_path__ + "static/media/foto 3_parque micaela bastidas_foto Milagros Portilla.1123deda.jpg";